// extracted by mini-css-extract-plugin
export var buttonWrapper = "button-module--buttonWrapper--S05pS";
export var button = "button-module--button--3xGP0";
export var centered = "button-module--centered--24TWK";
export var primary = "button-module--primary--acjwc";
export var secondary = "button-module--secondary--1JiD7";
export var tertiary = "button-module--tertiary--2BfMT";
export var disabled = "button-module--disabled--1joxm";